/* ==========================================================================
   UGC rail video playback
   --------------------------------------------------------------------------
   Lazy loads each video only when it approaches the viewport, autoplays it
   muted while visible, and pauses it the moment it scrolls out. Nothing is
   fetched for videos the visitor never scrolls to.

   Anyone with reduced motion enabled gets the poster frame and no autoplay;
   they can still start a video by tapping it.

   Tapping any video toggles play/pause, which is what makes this compliant
   with WCAG 2.2.2 — moving content that runs for more than five seconds has
   to be pausable by the visitor.
   ========================================================================== */

(function () {
  var videos = document.querySelectorAll('[data-ugc-video]');
  if (!videos.length) return;

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function loadSources(video) {
    if (video.dataset.loaded === 'true') return;
    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].src = sources[i].getAttribute('data-src');
      sources[i].removeAttribute('data-src');
    }
    video.load();
    video.dataset.loaded = 'true';
  }

  function markPaused(video, paused) {
    var item = video.closest('.ugc_item');
    if (!item) return;
    item.classList.toggle('is_paused', paused);
  }

  function tryPlay(video) {
    if (video.dataset.userPaused === 'true') return;
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      // Autoplay can still be refused (low power mode, data saver). Not an
      // error worth surfacing — the poster frame stays put.
      attempt.catch(function () {
        markPaused(video, true);
      });
    }
  }

  // Tap to toggle. Also the only way to start playback under reduced motion.
  for (var i = 0; i < videos.length; i++) {
    (function (video) {
      video.addEventListener('click', function () {
        loadSources(video);
        if (video.paused) {
          video.dataset.userPaused = 'false';
          tryPlay(video);
          markPaused(video, false);
        } else {
          video.pause();
          video.dataset.userPaused = 'true';
          markPaused(video, true);
        }
      });
    })(videos[i]);
  }

  if (prefersReducedMotion) return;

  if (!('IntersectionObserver' in window)) {
    // No observer: load and play everything rather than showing dead posters.
    for (var j = 0; j < videos.length; j++) {
      loadSources(videos[j]);
      tryPlay(videos[j]);
    }
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          loadSources(video);
          tryPlay(video);
        } else if (!video.paused) {
          video.pause();
        }
      });
    },
    { rootMargin: '300px', threshold: 0.25 }
  );

  for (var k = 0; k < videos.length; k++) {
    observer.observe(videos[k]);
  }
})();
